module.exports = __webpack_public_path__ + "img/C5.200e4f49.svg";